import { Component, Input, OnInit } from '@angular/core';
import {MatDialogRef as MatDialogRef } from '@angular/material/dialog';
// import { ManageMediaComponent } from '../manage-media.component';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  @Input() data;
  constructor( private dialogRef: MatDialogRef<any>) { }

  ngOnInit() {
  }
  
  copyUrl(url: string) {
    let selBox = document.createElement('textarea');
    selBox.value = url;
    document.body.appendChild(selBox)
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox)
  }
  close() {
    this.dialogRef.close();
  }

}
